'use client'

import { useEffect, useState } from 'react'

import Container from '@/components/ui/Container'
import { useConfigContext } from '@/context/ConfigProvider'
import { eGeneralInfo } from '@/types/enum'

export default function FooterInfo() {
  const [expanded, setExpanded] = useState(false)
  const [content, setContent] = useState('')

  const { locale, getBasic } = useConfigContext()
  const info = getBasic(eGeneralInfo.company_info)

  useEffect(() => {
    if (info && locale) {
      setContent(info)
    }
  }, [info, locale])

  const getPreviewText = () => {
    const paragraphs = content.split(/<\/p>/i)
    if (paragraphs.length > 2) {
      return (
        paragraphs.slice(0, 1).join('</p>') +
        `<span class='info-view-more-dot'>..</span><span class='info-view-more ml-1' id='view-more'>Xem thêm <i class='tgic icon-chevron-down'></i></span>`
      )
    }
    return content
  }

  const getFullTextWithCollapse = () => {
    const paragraphs = content.split(/<\/p>/i)
    if (paragraphs.length > 2) {
      return paragraphs.slice(0, paragraphs.length - 1).join('</p>') + `<span class='info-view-less' id='view-less'>Thu gọn <i class='tgic icon-chevron-up'></i></span></p>`
    }
    return content
  }

  useEffect(() => {
    const handleTouch = (event: TouchEvent) => {
      const target = event.target as HTMLElement
      if (target.closest('#view-more')) {
        setExpanded(true)
      } else if (target.closest('#view-less')) {
        setExpanded(false)
      }
    }

    document.addEventListener('touchstart', handleTouch)

    return () => {
      document.removeEventListener('touchstart', handleTouch)
    }
  }, [content])

  if (!content) return null

  return (
    <Container>
      <div className="text-sm px-3">
        <div id="company_info" dangerouslySetInnerHTML={{ __html: expanded ? getFullTextWithCollapse() : getPreviewText() }} />
      </div>
    </Container>
  )
}
